import { forwardRef, useEffect, useImperativeHandle } from "react";
import {
  Button,
  Col,
  Form,
  Image,
  message,
  Row,
  Tooltip,
  Upload,
  Typography,
} from "antd";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";

const { Title } = Typography;

const LottoImages = forwardRef((props, ref) => {
  const [messageApi, contextHolder] = message.useMessage();
  const { visible, data, onUpdate, photos, onUpdatePhotos, isEdit } = props;
  const [form] = Form.useForm();


  useImperativeHandle(ref, () => ({
    validate: () => form.validateFields(),
    getValues: () => ({
      ...form.getFieldsValue(),
      photos,
    }),
  }));


  useEffect(() => {
    if (visible) {
      if (isEdit && data) {
        form.setFieldsValue({ ...data });

      } else if (!data) {
        form.resetFields();
        onUpdatePhotos([]);
      }
    } else {
      form.resetFields();
      onUpdatePhotos([]);
    }
    // eslint-disable-next-line
  }, [visible, data, isEdit, form]);


  const handleChange = () => {
    const values = form.getFieldsValue();
    onUpdate({ ...values });
  };


  const handleUpload = ({ file, onSuccess }) => {
    onUpdatePhotos((prev) => [...prev, file]);
    onSuccess("ok");
    messageApi.open({ type: "success", content: "Nueva Foto Agregada" });
    handleChange();
  };


  return (
    <Form form={form} layout="vertical" onValuesChange={handleChange}>
      {contextHolder}
      <Form.List name="photos">
        {(fields, { remove }) => (
          <Row gutter={[16, 16]}>
            {fields.map(({ key, name }) => {
              const url = form.getFieldValue(["photos", name, "photoLink"]);
              return (
                <Col
                  key={key}
                  xs={24}
                  sm={12}
                  md={6}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <div style={{ position: "relative", textAlign: "center" }}>
                    <Image
                      src={url}
                      width={150}
                      height={150}
                      style={{ objectFit: "cover", borderRadius: 8 }}
                    />
                    <Tooltip title="Eliminar foto">
                      <Button
                        shape="circle"
                        icon={<DeleteOutlined />}
                        type="primary"
                        danger
                        size="small"
                        style={{
                          position: "absolute",
                          top: 8,
                          right: 8,
                        }}
                        onClick={() => {
                          remove(name);
                          messageApi.open({
                            type: "warning",
                            content: "Foto Eliminada",
                          });
                        }}
                      />
                    </Tooltip>
                  </div>
                </Col>
              );
            })}
          </Row>
        )}
      </Form.List>

      <Upload
        customRequest={handleUpload}
        showUploadList={false}
        accept="image/*"
        style={{ paddingTop: "20px" }}
      >
        <Button icon={<PlusOutlined />}>Agregar nueva foto</Button>
      </Upload>
      {photos.length > 0 && (
        <>
          <Title level={5}>Nuevas fotos (no subidas aún)</Title>
          <Row gutter={[16, 16]}>
            {photos.map((file, index) => (
              <Col
                key={index}
                xs={24}
                sm={12}
                md={6}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <div style={{ position: "relative", textAlign: "center" }}>
                  <Image
                    src={URL.createObjectURL(file)}
                    width={150}
                    height={150}
                    style={{ objectFit: "cover", borderRadius: 8 }}
                  />
                  <Tooltip title="Eliminar foto">
                    <Button
                      shape="circle"
                      icon={<DeleteOutlined />}
                      type="primary"
                      danger
                      size="small"
                      style={{ position: "absolute", top: 8, right: 8 }}
                      onClick={() => {
                        onUpdatePhotos((prev) => prev.filter((_, i) => i !== index));
                        handleChange();
                        messageApi.open({
                          type: "warning",
                          content: "Foto Eliminada",
                        });
                      }}
                    />
                  </Tooltip>
                </div>
              </Col>
            ))}
          </Row>
        </>
      )}
    </Form>
  );
});

export default LottoImages;
